import {Injectable} from "@angular/core";
import {ApiService} from "./api.service";
import {ContactData} from "../+contacts/contact.schema";
import {Headers} from "@angular/http";

@Injectable()
export class ContactService {

  constructor(private apiService: ApiService){}

  sendContact(contactData: ContactData){
    return this.apiService.post('/api/contact',JSON.stringify(contactData));
  }

  getCaptcha(){
    return this.apiService.get('/api/captcha',{ headers : new Headers({ 'Cache-Control': 'no-cache' }) });
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/+app/shared/contact.service.ts